<template>
    <div class="tableIngresos">
        <vs-row>
            <vs-col w="12">
                <vs-input v-if="users != ''" class="ml-auto searchWidth" v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
                <vs-button
                    v-if="users != ''"
                    success
                    relief
                    :active="active == 5" 
                    :loading="loadingExcel"
                    @click="active = 5, getInfoIngreso()"
                    class="ml-auto"
                >
                    <i class="fas fa-download mr-2"></i> Descargar reporte
                </vs-button>
                <vs-button
                    v-if="users != ''"
                    primary
                    relief
                    :active="active == 5" 
                    :loading="loadingExcel"
                    :disabled="!selected[0]"
                    @click="activeEliminar =! activeEliminar"
                    class="ml-auto"
                >
                    <i class="fas fa-check mr-2"></i> Eliminar pagos cancelados
                </vs-button>
                <div style="max-width: 100%;">
                    <h5 v-if="infoCard.alumnosTotal">Número total de alumnos: <strong>{{ infoCard.alumnosTotal}}</strong></h5>
                    <vs-table striped clas="table-responsive" 
                        v-dragscroll="{ target: '.vs-table', active: true }">
                        <template #thead>
                        <vs-tr>
                            <vs-th style="width: 50px !important; ">
                                <vs-checkbox
                                    :indeterminate="selected.length == users.length" v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, usersCancelados)"
                                />
                            </vs-th>
                            <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                                Alumno
                            </vs-th>
                            <vs-th>
                                Movimiento
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody style="vertical-align: top">
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in $vs.getSearch(users, search)"
                            :data="tr"
                            style="vertical-align: top"
                        >
                            <vs-td checkbox>
                                <vs-checkbox
                                    v-if="getContraCargos(tr)" :val="tr" v-model="selected" />
                            </vs-td>
                            <vs-td>
                                <div class="d-flex">
                                    <div>
                                        <vs-avatar circle>
                                            <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                                        </vs-avatar>
                                    </div>
                                    <div class="ml-2">
                                        <strong>{{ tr.nombre }}</strong>
                                        <p class="mb-0"><small>Matrícula</small></p>
                                        <strong>{{ tr.matricula }}</strong>
                                        <p class="mb-0"><small>Ciclo Escolar</small></p>
                                        <p><strong>{{ tr.cicloEscolar }}</strong></p>
                                        <vs-button
                                            success
                                            flat
                                            :href="'/estado-de-cuenta/' + tr.persona_id + '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar"
                                            blank
                                        >
                                            Ir a gestion de finanzas
                                        </vs-button>
                                        <div v-if="!getContraCargos(tr)" class="mb-1 fontMedium mini-chip info-red">
                                        Pago cancelado parcialmente, este pago actualmente esta afectando el saldo del estado de cuenta
                                        </div>
                                    </div>
                                </div>
                            </vs-td>
                            <vs-td>
                                <div v-for="info in tr.ingresos" :key="info.id">
                                    <vs-row>
                                        <vs-col w="8">
                                            <p class="mb-0"><small>Nombre</small></p>
                                            <p class="mb-0"> <strong>{{ info.codigoDetalle }}</strong> </p>
                                            <p class="mb-0"><small>No. Autorización</small></p>
                                            <p class="mb-0"> <strong>{{ info.noAutorizacion }} </strong></p>
                                            <p class="mb-0"><small>Fecha</small></p>
                                            <p class="mb-0"> <strong><i class="far fa-calendar"></i> {{ info.fecha }} </strong></p>
                                        </vs-col>
                                        <vs-col w="4">
                                            <p class="mb-0"><small>Monto</small></p>
                                            <p class="mb-0"><strong>{{ info.monto | currency }}</strong> </p>
                                        </vs-col>
                                    </vs-row>
                                    <hr>
                                </div>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay información
                        </template>
                    </vs-table>
                </div>
    
            </vs-col>
        </vs-row>
        <vs-dialog v-model="activeEliminar">
            <template #header>
            <h4 class="not-margin">
                Eliminar pagos cancelados
            </h4>
            </template>


            <div class="con-form">
                ¿Esta seguro de eliminar los pagos cancelados?
            </div><template #footer>
            <div class="footer-dialog">
                <vs-row>
                    <vs-col sm="6" lg="6">
                        <vs-button
                            danger
                            flat
                            @click="activeEliminar = false"
                        >
                            Cancelar
                        </vs-button>
                    </vs-col>
                    <vs-col sm="6" lg="6">
                        <vs-button
                            success
                            @click="postEliminarPagoCancelado()"
                            class="ml-auto"
                        >
                            Aceptar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </div>
        </template>
        </vs-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { dragscroll } from 'vue-dragscroll'
import reportes from '../../../../api/requests/reportes.js'
import profesor from '../../../../api/requests/landing-profesor'
export default {
    props:[
        'users',
        'cicloEscolar',
        'institucion',
        'ciclosEscolares',
        'instituciones',
        'filtros',
        'infoCard',
        'grupo'
    ],
    data(){
        return{
            search: '',
            active: 0,
            selected: [],
            allCheck: false,
            loadingExcel: false,
            activeEliminar:false,
            usersCancelados: []
        }
    },
    directives: {
       'dragscroll': dragscroll
    },
    methods: {

        checkAllElements(){
            this.users.forEach(i => {
                if(this.getContraCargos(i)){
                    this.usersCancelados.push(i)
                }
            })
        },
        
        async getInfoIngreso(){
            const loading = this.$vs.loading()
            try {
                
                let params = {
                    "institucion": this.institucion,
                    "cicloEscolar": this.cicloEscolar,
                    "type_response": "file",
                    "grupo": this.grupo,
                    "report": "pagosCancelados"
                }
                const response = await reportes.getInfoPendientes(params)
                loading.close()
                if(response){
                    window.location.href = response.request.responseURL;
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                }
            }
            catch{
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: 'bottom-right',
                    title: 'Hubo un error inesperado'
                })
            }
        },
        getContraCargos(info){
            let cancelado = true
            const ingresos = Object.values(info.ingresos)
            ingresos.forEach(i => {
                let contracargo = false
                ingresos.map(function(element){
                    if(i.codigoDetalle === element.codigoDetalle && (i.monto + element.monto) === 0){
                        contracargo = true
                    }
                })
                console.log(i)
                console.log(contracargo)
                console.log('---------------------------')
                if(!contracargo){
                    cancelado = false
                }
            })
            console.log(info)
            console.log(cancelado)
            console.log('++++++++++++++++++++++++++++++++++++')
            return cancelado
        },
        getInfo(){
            for(var x = 0;x < this.users.length; x++){
                const datos = Object.values(this.users[x].ingresos)
                datos.sort(function(a,b){
                    if(Math.abs(a.monto) > Math.abs(b.monto)){
                        return 1
                    }
                    if(Math.abs(a.monto) < Math.abs(b.monto)){
                        return -1
                    }
                    return 0
                })
                datos.sort(function(a,b){
                    if(a.codigoDetalle > b.codigoDetalle){
                        return 1
                    }
                    if(a.codigoDetalle < b.codigoDetalle){
                        return -1
                    }
                    return 0
                })
                this.users[x].ingresos = datos
            }
            console.log(this.users)
        },
        
        async postEliminarPagoCancelado(info){
            const loading = this.$vs.loading()
            let valor = 0
            const vue = this
            for(const element of this.selected) {
                valor += 1
                const info = element.ingresos
                for(var x = 0;x < info.length; x++){
                    try{
                        const params = {
                            tipo_store: 'eliminar_pagos_cancelados',
                            movimientos_ids: [
                                info[x].movimiento_id,
                            ]
                        }
                        const payload = Object.assign(params)
                        const response = await profesor.postEliminarPagoCancelado(params)
                        if(valor === vue.selected.length && (x + 1) === info.length){
                            loading.close()
                            vue.$emit('refreshTable')
                            vue.activeEliminar = false
                            vue.$vs.notification({
                                progress: 'auto',
                                color: 'success',
                                position: null,
                                title: 'Operación éxitosa',
                            })
                            this.selected = []
                        }
                    }catch(error){
                        console.log(error)
                        if(valor === vue.selected.length){
                            loading.close()
                            vue.activeEliminarMasivo = false
                            vue.$vs.notification({
                                progress: 'auto',
                                color: 'danger',
                                position: null,
                                title: 'Hubo un problema',
                            })
                            this.selected = []
                        }
                    }
                }
                // try {
                //     const params = {
                //         registro_academico_crn_id: element.registro_academico_crn_id,
                //         ciclo_escolar_id: element.ciclo_escolar_id,
                //         institucion_id: element.institucion_id,
                //         registro_academico_id: element.registro_academico_id,
                //         codigo_sesion_id: element.codigo_sesion_id,
                //         persona_docente_id: element.persona_docente_id
                //     }
                //     const response = await reportes.getEliminarGrupoAcademico(params)
                //     if(valor === vue.selected.length){
                //         loading.close()
                //         vue.$emit('refreshTable')
                //         vue.activeEliminarMasivo = false
                //         vue.$vs.notification({
                //             progress: 'auto',
                //             color: 'success',
                //             position: null,
                //             title: 'Operación éxitosa',
                //             text: response.data.message
                //         })
                //     }
                // }
                // catch(error){
                //     if(valor === vue.selected.length){
                //         loading.close()
                //         vue.activeEliminarMasivo = false
                //         vue.$vs.notification({
                //             progress: 'auto',
                //             color: 'danger',
                //             position: null,
                //             title: 'Hubo un problema',
                //             text: error.response.data.message 
                //         })
                //     }
                // }
            }
        },
        // async postEliminarPagoCancelado (type) {
        //     if(this.selected !=  ''){
        //         const loading = this.$vs.loading()
        //         let datos = []
        //         let numero = 0
        //         for(var x = 0;x < this.selected.length; x++){
        //                 numero += 1
        //             try {
        //                 const response = await reportes.getActualizarSaldos(alumnos)
        //                 this.$vs.notification({
        //                     progress: 'auto',
        //                     color: 'success',
        //                     position: 'bottom-right',
        //                     title: 'Operación éxitosa',
        //                     text: response.data.message
        //                 })

        //             } catch (error) {
        //                 console.log(error)
        //                 loading.close()
        //             }
        //         }

        //         if(this.selected.length == numero){
        //                 this.selected = []
        //                 this.$emit('refreshTable')
        //                 loading.close()
        //         }
        //             console.log(numero)
        //         return
        //         const vm = this
        //             try {
        //                 const response = await reportes.getActualizarSaldos(alumnos)
        //                 this.$vs.notification({
        //                     progress: 'auto',
        //                     color: 'success',
        //                     position: 'bottom-right',
        //                     title: 'Operación éxitosa',
        //                     text: response.data.message
        //                 })
        //                 this.selected = []
        //                 this.$emit('refreshTable')
        //                 loading.close()

        //             } catch (error) {
        //                 console.log(error)
        //                 loading.close()
        //             }
        //     }else {
        //         this.$vs.notification({
        //             progress: 'auto',
        //             color: 'danger',
        //             position: 'bottom-right',
        //             title: 'Selecciona al menos un alumno para realizar la acción',
        //         })
        //     }
        // },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    },
    watch:{
        users(){
            this.getInfo()
            this.checkAllElements()
        }
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .searchWidth{
        @media only screen and (max-width: 768px) {
            width: 100%;
        }
        @media only screen and (min-width: 768px) {
            width: 30%;
        }
    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .trecientos{
        width: 300px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;

    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>
<style scoped>
    /* .vs-table-content {
        overflow-x: auto !important;
    } */
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .info-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
        padding: 5px 12px;
        display: inline-block;
        cursor: default;
        border-radius: 20px;
        transition: .3s cubic-bezier(.25,.8,.25,1);
        transition-property: background-color,color,opacity,transform,box-shadow;
        will-change: background-color,color,opacity,transform,box-shadow;
        font-size: 13px;
        /* line-height: 32px; */
        vertical-align: middle;
        /* white-space: nowrap; */
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .vs-avatar img{
        object-fit:contain;
    }

</style>

<style>
    .tableIngresos .vs-table__th__content{
        justify-content: center;
    }

</style>